import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bed, Bath, MapPin, ArrowUpRight } from 'lucide-react';
import { ddfAPI } from '../services/api';

const fmtPrice = (n) => `$${Number(n).toLocaleString('en-CA')}`;

const ListingCard = ({ p }) => (
  <Link
    to={`/property/${p.id}`}
    className="group block bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
    data-testid={`my-listing-card-${p.id}`}
  >
    <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
      <img src={p.image} alt={p.address} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      <span className="absolute top-3 left-3 bg-red-600 text-white text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
        My Listing
      </span>
    </div>
    <div className="p-5">
      <p className="text-2xl font-bold text-gray-900" data-testid={`my-listing-price-${p.id}`}>{fmtPrice(p.price)}</p>
      <p className="mt-1 font-medium text-gray-800 capitalize">{p.address?.toLowerCase()}</p>
      <p className="flex items-center gap-1 text-sm text-gray-500 mt-1"><MapPin size={14} />{p.city}</p>
      <div className="flex items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex gap-4">
          <span className="flex items-center gap-1"><Bed size={16} />{p.beds} bd</span>
          <span className="flex items-center gap-1"><Bath size={16} />{p.baths} ba</span>
        </div>
        <span className="flex items-center gap-1 text-red-600 font-semibold group-hover:gap-2 transition-[gap]">
          View <ArrowUpRight size={16} />
        </span>
      </div>
    </div>
  </Link>
);

const MyActiveListings = () => {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    ddfAPI.getMyListings().then(setListings).catch(() => setListings([]));
  }, []);

  if (!listings.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 pb-16" data-testid="my-active-listings">
      <p className="text-red-600 uppercase tracking-widest text-xs font-semibold mb-2">On the Market Now</p>
      <h2 className="text-3xl font-bold text-gray-900 mb-8">My Active Listings</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {listings.map((p) => <ListingCard key={p.id} p={p} />)}
      </div>
    </section>
  );
};

export default MyActiveListings;
